import IconText from "../../IconText";
import {faElevator} from "@fortawesome/free-solid-svg-icons";

export default function ElevatorMaintenance() {
    return (
        <div className={"blog-body"}>
            <h1><IconText text={"2.2. Elevator Maintenance"} icon={faElevator}/></h1>
            <h2>Question</h2>
            <div className={"blog-quote"}>
                <p>
                    You've been assigned the onerous task of elevator maintenance -- ugh! It wouldn't be so bad,
                    except that
                    all the elevator documentation has been lying in a disorganized pile at the bottom of a filing
                    cabinet
                    for years, and you don't even know what elevator version numbers you'll be working on.
                </p>
                <p>
                    Elevator versions are represented by a series of numbers, divided up into major, minor and
                    revision
                    integers. New versions of an elevator increase the major number, e.g. 1, 2, 3, and so on. When
                    new
                    features are added to an elevator without being a complete new version, a second number named
                    "minor"
                    can be used to represent those new additions, e.g. 1.0, 1.1, 1.2, etc. Small fixes or
                    maintenance work
                    can be represented by a third number named "revision", e.g. 1.1.1, 1.1.2, 1.2.0, and so on. The
                    number
                    zero can be used as a major for pre-release versions of elevators, e.g. 0.1, 0.5, 0.9.2, etc
                    (Commander
                    Lambda is careful to always beta test her new technology, with her loyal henchmen as subjects!).
                </p>
                <p>
                    Given a list of elevator versions represented as strings, write a function solution(l) that
                    returns the
                    same list sorted in ascending order by major, minor, and revision number so that you can
                    identify the
                    current elevator version. The versions in list l will always contain major numbers, but minor
                    and
                    revision numbers are optional. If the version contains a revision number, then it will also have
                    a minor
                    number.
                </p>
                <p>
                    For example, given the list l as ["1.1.2", "1.0", "1.3.3", "1.0.12", "1.0.2"], the function
                    solution(l)
                    would return the list ["1.0", "1.0.2", "1.0.12", "1.1.2", "1.3.3"]. If two or more versions are
                    equivalent but one version contains more numbers than the others, then these versions must be
                    sorted
                    ascending based on how many numbers they have, e.g ["1", "1.0", "1.0.0"]. The number of elements
                    in the
                    list l will be at least 1 and will not exceed 100.
                </p>
                <p>
                    <b>Test cases</b>
                </p>
                <p>
                    Input: <br/>
                    solution.solution(["1.11", "2.0.0", "1.2", "2", "0.1", "1.2.1", "1.1.1", "2.0"]) <br/>
                    Output: <br/>
                    0.1,1.1.1,1.2,1.2.1,1.11,2,2.0,2.0.0 <br/><br/>

                    Input: <br/>
                    solution.solution(["1.1.2", "1.0", "1.3.3", "1.0.12", "1.0.2"]) <br/>
                    Output: <br/>
                    1.0,1.0.2,1.0.12,1.1.2,1.3.3 <br/>
                </p>
            </div>

            <h2>Solution</h2>
            <p>
                Surprisingly easy question. Python's <code>sort</code> method has a <code>key</code> parameter that
                can be
                used to sort a list of strings based on a custom key function. We can define a custom key function
                that
                splits the string on the '.' character, converts each part of the split string to an integer, and
                returns
                the list of integer parts. This way, we can sort the list of strings based on the major, minor, and
                revision
                numbers.
            </p>

            <h2>Code</h2>
            <pre><code className="language-python">{`def sort_key(s):
    """
    Splits the string on the '.' character,
    converts each part of the split string to an integer,
    and returns the list of integer parts.
    """
    # Splitting the string on the '.' character
    split_string = s.split('.')

    # Converting each part of the split string to an integer
    integer_parts = map(int, split_string)

    return list(integer_parts)

def solution(l):
    # Sorting the list using the defined key function
    l.sort(key=sort_key)

    # Returning the sorted list
    return l`}</code></pre>
        </div>
    );
}